import { BulkProcessFormData, BulkProcessRow } from './bulk-process-utils.type';

// Create standardized import data for bulk process operations
export const createImportDataForBulkProcess = (
  formData: BulkProcessFormData,
  rows: BulkProcessRow[],
  totalQuantity?: number
) => ({
  offerId: formData.offerId,
  channelId: formData.channelId,
  eventId: formData.eventId,
  rows,
  addOns: formData.addOns
    ? formData.addOns.map((addon) => ({
        id: addon,
        quantity: totalQuantity ?? rows.length,
      }))
    : [],
});
